/* eslint-disable react/prop-types */
import React, { useState, useEffect, useContext } from 'react';
import Select from 'react-select';
import Grid from '@material-ui/core/Grid';

import Loading from '../../components/loading/Loading';
import FlashContext from '../../components/contexts/FlashContext';
import api from '../../service/axios/api';
import ReconciliationErrorsTable from './ReconciliationErrorsTable';

const selectStyles = {
  control: (provided) => ({ ...provided, height: 56, minHeight: 56, width: 220 }),
  menu: (provided) => ({ ...provided, zIndex: 9999 }),
};

const providerOptions = [
  { value: '', label: 'Todos os provedores' },
  { value: 'Niky', label: 'Niky' },
  { value: 'BePay', label: 'BePay' },
];

export default function ReconciliationErrors() {
  const { notifyError } = useContext(FlashContext);

  const [loading, setLoading] = useState(false);
  const [docs, setDocs] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(0);
  const [itens, setItens] = useState(10);
  const [provider, setProvider] = useState(providerOptions[0]);

  const searchData = async () => {
    setLoading(true);
    try {
      const { data } = await api.cards.getReconciliationErrors({
        page: page + 1,
        limit: itens,
        provider: provider.value || undefined,
      });
      setDocs(data.docs || []);
      setTotal(data.total || 0);
    } catch (error) {
      notifyError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    searchData();
  }, [page, itens, provider]);

  const handleProviderChange = (opt) => {
    setProvider(opt);
    setPage(0);
  };

  return (
    <div className="col-sm-12" style={{ marginTop: 0 }}>
      <Loading open={loading} msg="Buscando itens rejeitados..." />

      <div
        className="col-sm-12"
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <h3>
          Erros de Conciliação
        </h3>
      </div>

      <Grid container spacing={3} style={{ marginTop: 8, marginBottom: 8 }}>
        <Grid item xs={12} sm={4}>
          <Select
            value={provider}
            onChange={handleProviderChange}
            options={providerOptions}
            styles={selectStyles}
            isSearchable={false}
          />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid item xs={12} sm={12}>
          <ReconciliationErrorsTable
            docs={docs}
            page={page}
            setPage={setPage}
            itens={itens}
            setItens={setItens}
            total={total}
            searchData={searchData}
          />
        </Grid>
      </Grid>
    </div>
  );
}
